module.exports = "<div class=\"provider-status-header__data\" ng-class=\"$ctrl.currentStatus.className\"> {{ $ctrl.currentStatus.title }} </div> ";